<section class="modal-content modal-content-right">
  <button
    cjButton
    aria-label="Close"
    class="modal-close"
    tabIndex="-1"
    [disabled]="isProcessing"
    (click)="onClose()"
  >
    <cj-icon icon="times" pack="font-awesome-solid"></cj-icon>
  </button>

  <div *ngIf="isLoading" class="flex items-center justify-center text-center" [style.height.%]="100">
    <img src="./assets/images/preloader.gif" width="90"/>
  </div>

  <div *ngIf="!isLoading" class="flex flex-column">
    <div class="header-content mx-6 pt-6">    
      <h5>
        {{ getHeaderLabel() }}
      </h5>

      <div class="mt-3">
        <a
          class="font-medium text-blue-90"
          [style.pointer-events]="isProcessing ? 'none' : 'auto'"
          (click)="onBack()"
        >
          <cj-icon class="mr-1" icon="chevron-left" pack="font-awesome-solid"></cj-icon>
          Back to {{ getBackLabel() }}
        </a>
      </div>
    </div>

    <section class="body-content text-center py-14 px-6">
      <div class="mb-8 font-bold" [style.font-size.px]="18">
        {{ currentStep !== 'pay-form' ? 'Select Payment Method' : 'Invoice and Payment Summary' }}
      </div>

      <div *ngIf="currentStep === 'pay-options'">
        <div class="flex gap-6 items-center justify-center">
          <ng-container *ngFor="let option of paymentOptions">
            <div 
              class="option-item flex flex-col flex-grow-1 items-center justify-center h-48"
              (click)="onOptionSelect(option.value)"
            >
              <div class="text-cyan-70 h-16 w-24 mb-3">
                <cj-svg-icon [icon]="option.icon"></cj-svg-icon>
              </div>
              <span class="font-medium">{{ option.name }}</span>
            </div>
          </ng-container>
        </div>
      </div>

      <div *ngIf="currentStep === 'pay-methods'">
        <div class="flex gap-6 items-center justify-center">
          <ng-container *ngFor="let method of paymentMethods">
            <div 
              *ngIf="method.enabled"
              class="option-item flex flex-col flex-grow-1 items-center justify-center h-48"
              (click)="onMethodSelect(method)"
            >
              <div class="text-cyan-70 h-14 w-24 mb-4">
                <cj-svg-icon [icon]="method.icon"></cj-svg-icon>
              </div>
              <span class="font-medium">{{ method.name }}</span>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="w-10/12 mx-auto flex flex-col gap-2.5" *ngIf="currentStep === 'pay-form'">
        <section class="form-container grid grid-cols-12">
          <label class="form-label col-span-5">Invoice Number</label>
          <span class="col-span-7">{{ invoice.invoiceNumber }}</span>
        </section>

        <section class="form-container grid grid-cols-12">
          <label class="form-label col-span-5">Payment Details</label>
          <span class="col-span-7">
            {{ !isPartialPayment ? 'Full Payment' : 'Partial Payment' }}, {{ selectedMethod.name }}
          </span>
        </section>

        <section class="form-container grid grid-cols-12">
          <label class="form-label col-span-5">Customer Details</label>
          <div class="col-span-7 flex flex-col gap-2">
            <label class="form-label">{{ getCustomerName() }}</label>
            <span>{{ getDefaultCustomerAddress() }}</span>
          </div>
        </section>

        <section class="form-container grid grid-cols-12 mb-2.5">
          <label class="form-label mb-3 col-span-{{ selectedMethod.value === 'cash' ? '5' : '12' }}">
            {{ selectedMethod.name }}
          </label>

          <ng-container>
            <app-cash-pay
              *ngIf="selectedMethod.value === 'cash'"
              class="col-span-7"
              [invoiceBalance]="invoice.status === 'Partial' || isPartialPayment ? displayBalance : invoice.balance"
              [isProcessing]="isProcessing"
            ></app-cash-pay>

            <app-manual-pay
              *ngIf="selectedMethod.value === 'manual'"
              class="col-span-12"
              [invoiceModel]="invoice"
              [invoiceBalance]="invoice.status === 'Partial' || isPartialPayment ? displayBalance : invoice.balance"
              [isProcessing]="isProcessing"
              [isSubmitted]="isSubmitted"
              (onValueChange)="onValueChange('manualForm', $event)"
            ></app-manual-pay>

            <app-ach-pay
              *ngIf="selectedMethod.value === 'ach'"
              class="col-span-12"
              [invoice]="invoice"
              [invoiceBalance]="invoice.status === 'Partial' || isPartialPayment ? displayBalance : invoice.balance"
              [customerAddresses]="customerAddresses"
              [isProcessing]="isProcessing"
              [isSubmitted]="isSubmitted"
              [addressId]="customerAddress?.Id"
              [customerId]="customer.Id"
              (onValueChange)="onValueChange('achForm', $event)"
              (onAddressAdd)="onAddressAdd()"
              (onACHSelect)="onACHSelect($event)"
              (onACHAdd)="onACHAdd($event)"
            ></app-ach-pay>

            <app-card-pay
              *ngIf="selectedMethod.value === 'card'"
              class="col-span-12"
              [invoice]="invoice"
              [invoiceBalance]="invoice.status === 'Partial' || isPartialPayment ? displayBalance : invoice.balance"
              [invoiceSettings]="invoiceSettings"
              [customer]="customer"
              [customerAddresses]="customerAddresses"
              [isProcessing]="isProcessing"
              [isSubmitted]="isSubmitted"
              [cardCVV]="cardInfo?.cvn"
              [selectedCard]="selectedCard"
              [publicAPIKey]="locationData.API_Key || ''"
              [addressId]="customerAddress?.Id"
              [addressShippingId]="shippingAddress?.Id"
              (onValueChange)="onValueChange('cardForm', $event)"
              (onAddressAdd)="onAddressAdd($event)"
              (onCardSelect)="onCardSelect($event)"
              (onCardAdd)="onCardAdd($event)"
              (onTokenReceive)="onTokenReceive($event)"
            ></app-card-pay>
          </ng-container>
        </section>

        <ng-container>
          <div class="px-2 flex items-center">
            <cj-checkbox [disabled]="isProcessing" [(ngModel)]="isAgreedToTerms">
              Customer has read and agree to the
            </cj-checkbox>
            <a
              class="mb-0.5 ml-1 font-semibold"
              [class.text-disabled]="isProcessing"
              [style.pointer-events]="isProcessing ? 'none' : 'unset'"
              (click)="onOpenTermsAndCondition()"
            >Terms and Conditions</a>
          </div>

          <div class="px-2 self-start" *ngIf="['cash', 'manual'].includes(selectedMethod.value)">
            <cj-checkbox [disabled]="isProcessing" [(ngModel)]="isEmailReceipt">
              Send Receipt to Client
            </cj-checkbox>
          </div>

          <div class="px-2 self-start" *ngIf="isNewCard">
            <cj-checkbox [disabled]="isProcessing" [(ngModel)]="isSaveCard">
              Save card to customer’s account
            </cj-checkbox>
          </div>

          <div class="px-2 self-start" *ngIf="isNewACH">
            <cj-checkbox [disabled]="isProcessing" [(ngModel)]="isSaveACH">
              Save ACH Detail to customer’s account
            </cj-checkbox>
          </div>
        </ng-container>

        <div class="flex justify-end gap-2.5 mt-8">
          <button
            cjButton
            outline
            size="large"
            [disabled]="isProcessing"
            (click)="onReturnInvoiceDetails()"
          >Cancel Payment</button>

          <button
            *ngIf="!isNewCard"
            cjButton
            type="submit"
            size="large"
            [disabled]="isProcessing"
            (click)="onProcessPayment()"
          >
            <span *ngIf="isProcessing" class="flex items-center mr-2">
              <cj-icon class="fa-spin icon-giant" icon="spinner" pack="font-awesome-solid"></cj-icon>
            </span>
            <span *ngIf="!isProcessing" class="flex items-center mr-2">
              <cj-icon class="icon-giant" icon="check-circle" pack="font-awesome-solid"></cj-icon>
            </span>
            {{ !isProcessing ? 'Process Payment' : 'Processing...' }}
          </button>

          <ng-container *ngIf="isNewCard">
            <div id="credit-card-submit" [hidden]="isProcessing"></div>
            <button
              [hidden]="!isProcessing"
              cjButton
              size="large"
              [disabled]="isProcessing"
              [style.width.px]="300"
            >
              <cj-icon class="fa-spin icon-giant" icon="spinner" pack="font-awesome-solid"></cj-icon>
              Processing...
            </button>
          </ng-container>
        </div>
      </div>
    </section>

    <div class="footer-content flex justify-end mx-6 pb-6" *ngIf="currentStep !== 'pay-form'">
      <button
        cjButton
        outline
        size="large"
        (click)="onReturnInvoiceDetails()"
      >Cancel</button>
    </div>
  </div>
</section>